// extracted by mini-css-extract-plugin
module.exports = {"root":"Placeholder__root--1HF1F","placeholder":"Placeholder__placeholder--3w1HY"};